module.exports = __webpack_public_path__ + "img/onlineTicketingAct.e15b7552.png";